module.exports = __webpack_public_path__ + "img/home0.1cec56e5.png";